import React from 'react';
import { Button } from '@material-ui/core';
import * as PropTypes from 'prop-types';
import variables from '../../../utils/variables';
import image from '../../../assets/section1.svg';
import Icon from '../../../components/Icon';
import './inde.css';

const Section1 = (props) => {
    const handleStudio = () => {
        window.open('https://app.omniflix.studio', '_blank');
    };

    return (
        <section className="section1">
            <div className="left_content">
                <div className="info">
                    <p>{variables[props.lang]['section1_text1']}</p>
                    <p>{variables[props.lang]['section1_text3']}</p>
                </div>
                <div className="studio_button_div">
                    <Button
                        className="studio_button"
                        variant="contained"
                        onClick={handleStudio}>
                        {variables[props.lang]['explore_studio']}
                        <Icon className="arrow" icon="arrow"/>
                    </Button>
                    <span/>
                </div>
            </div>
            <img alt="studio description" src={image}/>
        </section>
    );
};

Section1.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default Section1;
